export default "/institutions/btg.svg";